import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError, CustomerManagementAction, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { MissingPasswordAction } from "./missing-password.action";
import { MISSING_PASSWORD_MESSAGE_CODES, MISSING_PASSWORD_MESSAGE_CONTEXT } from "./missing-password.const";
import { MissingPasswordService } from "./missing-password.service";

/**
 * @deprecated - [fabric-deprecated] - Use MissingPasswordService from app-account mfe instead
 */
@Injectable()
export class MissingPasswordEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.SetMissingPassword) instead
	 */
	setMissingPassword$ = createEffect(() =>
		this.actions$.pipe(
			ofType(MissingPasswordAction.set),
			switchMap(({ model }) =>
				this.service.set(model).pipe(
					map(() => MissingPasswordAction.setSuccess()),
					catchError((error: AppError) => of(MissingPasswordAction.setFail(error)))
				)
			)
		)
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.SetMissingPassword) instead
	 */
	setMissingPasswordSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(MissingPasswordAction.setSuccess),
			map(() => this.customerManagementAction.updateCustomerCredentialTypes("UsernamePasswordCredential"))
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[MissingPasswordAction.setFail.type]: MISSING_PASSWORD_MESSAGE_CONTEXT.setMissingPassword,
			}),
			this.messageService.mapClearByContext$({
				[MissingPasswordAction.set.type]: MISSING_PASSWORD_MESSAGE_CONTEXT.setMissingPassword,
			}),
			this.messageService.map$({
				[MissingPasswordAction.setSuccess.type]: {
					context: MISSING_PASSWORD_MESSAGE_CONTEXT.setMissingPassword,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: MISSING_PASSWORD_MESSAGE_CODES.setMissingPassword.success,
				},
			})
		)
	);

	constructor(
		private actions$: Actions,
		private service: MissingPasswordService,
		private messageService: MessageService,
		private customerManagementAction: CustomerManagementAction
	) {}
}
